<template>
<div style="position:absolute;width:100%;height:100%;">


  <div class="heightbox" style="position:relative;">
    <div class="dasw" :style="'text-align: '+($vuetify.breakpoint.smAndDown?'center':'right')+';'">
      <span class="display-4" style="color:#414141;">&lt;<span style="color: orange;">{{ $vuetify.breakpoint.xsOnly?"W":"W_Dev" }}</span>&gt;</span>
      <br><br>
      <q>Making the world a better place</q>
      <!-- <q>Looking for <a style="text-decoration:none;" href="http://127.0.0.1:8080">127.0.0.1:8080</a>?</q> -->
    </div>
  </div>
  <!-- <hr style="transform: rotate(2deg);"> -->
  <div style="background:#eeeeee;">
    <v-container>
      <div class="textcontentextreme">
        <div class="display-1">Hello there!</div><br> In the digital world I call myself WuerfelDev. I am coding all kind of stuff, here you can check out some of the
        <router-link to="/projects">things I have done</router-link>.
        <br>As you may have noticed this webpage is highly inspired by Ubuntu (12.04 &amp; 18.04) and Ubuntu Touch on mobile. The site looks alike my desktop which features the
        <a target="_blank" href="https://github.com/adapta-project/adapta-gtk-theme/blob/master/README.md">adapta</a> theme (and the <a target="_blank" href="https://snwh.org/paper">paper</a> icon pack). The icons I used here are google's material icons.
        <br>Actually just a week after finishing this page I switched to the <a target="_blank" href="https://i3wm.org/">i3</a> window manager, funny!
        <br><br>For the most awesome experience you should enable the fullscreen mode by clicking on the time{{$vuetify.breakpoint.smAndDown?"":" or by the using the top right menu"}}.
      </div>
    </v-container>
  </div>
  <!-- <hr style="transform: rotate(2deg);margin-top:30px;margin-bottom:30px;"> -->






  <div style="text-align: center;">

    <br><br>

    <div v-if="isWindows()" style="background:#eeeeee;padding-top:30px;padding-bottom:30px;margin-top:60px;margin-bottom:50px;">
      <a target="blank" href="http://www.biebian.sourceforge.net"><img style="position:relative;max-width:100%;" alt="Get Biebian here" src="http://www.biebian.sourceforge.net/JBLad.png" /></a>
    </div>

    <br><br>

    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 sm6 md3>
          <a href="https://twitter.com/WuerfelDev" target="_blank" class="imginside connectbox toosmall">
            <v-card dark style="background:#1da1f2;">
              <v-card-text>
                <img src="../assets/Twitter_Logo_WhiteOnBlue.svg"><br><span>Twitter</span>
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <a href="https://gitlab.com/WuerfelDev" target="_blank" class="imginside connectbox">
            <v-card dark>
              <v-card-text>
                <img src="../assets/logo-gitlab.svg"><br><span>GitLab</span>
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <a href="https://apps.rebble.io/en_US/developer/56dab64f59ab332abd00000b/1" target="_blank" class="imginside connectbox">
            <v-card dark style="background:#f85050;">
              <v-card-text>
                <img src="../assets/Pebble_logo.svg"><br><span>Pebble Appstore</span>
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <a href="https://play.google.com/store/apps/developer?id=WuerfelDev" target="_blank" class="imginside connectbox toosmall">
            <v-card dark style="background:#836382;">
              <v-card-text>
                <img src="../assets/google-play-badge.png"><br><span>Google Play Store</span>
              </v-card-text>
            </v-card>
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</div>
</template>

<script>
export default {
  name: "beta-page",
  methods: {
    isWindows() {
      return navigator.appVersion.indexOf('Win') != -1
    }
  }
}
</script>
<style>
.connectbox {
  outline: 0;
  text-decoration: none;
}

.connectbox img {
  height: 40px;
  transform: scale(1);
  transition: all .3s;
}

.connectbox:hover img {
  transform: scale(1.3);
}

.connectbox.toosmall img {
  transform: scale(1.3);
}

.connectbox.toosmall:hover img {
  transform: scale(1.6);
}

.connectbox span {
  transition: all .3s;
  opacity: 1;
  z-index: 1;
}

.connectbox:hover span {
  opacity: 0;
}

.dasw {
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.heightbox {
  min-height: 80%;
}
</style>



// WEBPACK FOOTER //
// src/content/home-page.vue